<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          title="Activity log"
        >
          <v-data-table
                  :items="activites"
                  hide-actions
          >
            <template
                    slot="headerCell"
                    slot-scope="{ header }"
            >
              <span
                      class="subheading font-weight-light text-success text--darken-3"
                      v-text="header.text"
              />
            </template>
            <template
                    slot="items"
                    slot-scope="{ item }"
            >

              <!--<td>{{ item.subject_type }}</td>-->
              <td> <span v-html="item.description"></span></td>
              <td>{{ new Date(item.created_at) | dateFormat('D MMM, YYYY h:mm A ') }}</td>
             <!-- <td>
                <pre>{{ item.properties.attributes | pretty }}</pre>

              </td>-->

            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {listActivity} from "../api/routes";

export default {
  data () {
    return {
      activites:[]
    }
  },
  mounted() {
    this.getlistData();
  },
  methods: {
    getlistData(){
      listActivity()
              .then(response => {
                this.activites =response.data;
              })
              .catch(error => {
                console.log(error);
              })
              .finally(() => {

              })
    },
  }

}
</script>
